import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const SolicitudesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getSolicitudesLaboratorio = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "laboratorio_produccion/solicitudes_laboratorio",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const verificarRepeticionAnalisis = async (analisisId) => {
        try {
            setCargando(true);
            const response = await api.get(
                `laboratorio_produccion/verificar_repeticion_analisis/${analisisId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const repetirAnalisis = async (analisisId, data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `laboratorio_produccion/repetir_analisis/${analisisId}`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getRepeticionesAnalisis = async (analisisId, params) => {
        try {
            setCargando(true);
            const response = await api.get(
                `laboratorio_produccion/repeticiones_analisis/${analisisId}`,
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getSolicitudesLaboratorio,
        getRepeticionesAnalisis,
        verificarRepeticionAnalisis,
        repetirAnalisis,
        cargando,
    };
};
